const user = (state = null, action) => {
  switch (action.type) {
    case 'USER_NAME':
      return Object.assign({}, state, { name: action.name })
    default:
      return state
  }
}

export default user